<template>
	<div class="m-link-area">
		<img v-if="unitData.data && unitData.data.image" :src="unitData.data.image" alt="">
		<p v-else class="unit-empty">未设置图片</p>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				unitData: {},
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-link-area {
		img {
			width: 100%;
			max-height: none;
		}
	}
</style>
